export default __webpack_public_path__ + "static/media/standard-confetti.7911754a.webm";